import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenu } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import { MapDrawMapboxComponent } from '../../../../auxiliares/map-draw-mapbox/map-draw-mapbox.component';
import { MapaFacilV2Component } from '../../../../auxiliares/mapbox/mapa-facil-v2.component';
import { CamarasMultipleComponent } from '../../../standalone/camaras-multiple/camaras-multiple.component';
import { StreamCamaraComponent } from '../../../standalone/stream-camara/stream-camara.component';
import { BotonDePanicoRoutingModule } from './boton-de-panico.routing.module';
import { ListadoSirenasComponent } from './listado-sirenas/listado-sirenas.component';
import { MapaSirenasComponent } from './mapa-sirenas/mapa-sirenas.component';
import { IslaSirenasComponent } from './mapa-sirenas/isla-sirenas/isla-sirenas.component';
import { FlotanteSirenasComponent } from './mapa-sirenas/flotante-sirenas/flotante-sirenas.component';
import { SelectorTipoMapaComponent } from '../../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
@NgModule({
  declarations: [
    ListadoSirenasComponent,
    MapaSirenasComponent,
    IslaSirenasComponent,
    FlotanteSirenasComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    BotonDePanicoRoutingModule,
    MapDrawMapboxComponent,
    MapaFacilV2Component,
    MatMenu,
    MatCardModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    StreamCamaraComponent,
    CamarasMultipleComponent,
    SelectorTipoMapaComponent,
  ],
})
export class BotonDePanicoModule {}
